module.exports = __webpack_public_path__ + "img/LIGHTING 1 BW.6dd19c4.svg";